// shared/ActionCard.jsx  
// Reusable action card component for strategic recommendations
// Extracted from CompetitiveAnalysisView.jsx for better reusability

import React from 'react';

/**
 * Action card component displaying strategic actions with steps
 * @param {Object} props - Component props
 * @param {Object} props.action - Action object with action, timeframe, and steps
 * @param {boolean} props.urgent - Whether this action is marked as urgent
 * @returns {JSX.Element} Action card component
 */
const ActionCard = ({ action, urgent = false }) => (
    <div className={`p-4 rounded-lg ${urgent ? 'bg-blue-50' : 'bg-gray-50'}`}>
        <div className="flex justify-between items-start mb-2">
            <div className="font-medium">{action.action || 'Unknown action'}</div>
            <div className={`text-sm ${urgent ? 'text-blue-600' : 'text-gray-600'}`}>
                {action.timeframe || 'No timeframe specified'}
            </div>
        </div>
        <div className="space-y-2">
            {(action.steps || []).map((step, index) => (
                <div key={index} className="flex items-center gap-2 text-sm">
                    <div className="w-5 h-5 rounded-full bg-white flex items-center justify-center">
                        {index + 1}
                    </div>
                    <div>{step}</div>
                </div>
            ))}
            {(!action.steps || action.steps.length === 0) && (
                <div className="text-sm text-gray-600">No specific steps provided</div>
            )}
        </div>
    </div>
);

export default ActionCard;
